export default __webpack_public_path__ + "static/media/marcelo.e84af0d6.png";